import { cloneDeep, get, zipWith } from 'lodash';
import { createSelector } from 'reselect';

import {
  getModalSplitByOwnership,
  getModalSplitByType,
  getModalSplitPublicTransitLever,
  getModalSplitSharedMobilityLever,
  getNumProjectionYears
} from '../index';

import {
  IAutorickshawSplit,
  ICarSplit,
  IModalSplit,
  IOwnershipMode,
  IPublicTransitSplit,
  ITwoWheelSplit,
  VehicleType
} from './../../types/city';

import {
  MODAL_SPLIT_BY_OWNERSHIP_BAU_GROWTH,
} from '../../../data/modelConstants';

// Produce a subsection slice just for car related material
export const adjustOwnershipGrowthForCar = (carModalSplit: ICarSplit, numYears: number, sharedMobilityLever: number) => {

  // First, let's calculate New Growth Rate for commercial cars
  const baseCommercialGrowth = get(MODAL_SPLIT_BY_OWNERSHIP_BAU_GROWTH, [VehicleType.car, 'commercial']);
  const commercialCarGrowth = baseCommercialGrowth * (1 + (sharedMobilityLever * 0.3));
  const adjCommercialCarFraction = numYears * commercialCarGrowth + carModalSplit.commercial;

  const carGrowth = MODAL_SPLIT_BY_OWNERSHIP_BAU_GROWTH[VehicleType.car];

  // Need to get old end percentage
  const prevPrivateCarSplit = numYears * carGrowth.private + carModalSplit.private;
  const prevNonCommercialTotal = prevPrivateCarSplit; // I21 - don't include public cars in this

  // Now, we apply normalizations!
  const nonCommercialCarFraction = 1 - adjCommercialCarFraction; // H22

  // now we get the splits
  const commercialCarSplit = adjCommercialCarFraction;
  const privateCarSplit = (prevPrivateCarSplit / prevNonCommercialTotal) * nonCommercialCarFraction;
  const publicCarSplit = 0 // growthMap[VehicleType.car].public; - sheet hardcodes this in...

  // Sanity check KColumn in Adjustment Table
  // console.log('CarSplits', privateCarSplit, commercialCarSplit, publicCarSplit);
  return {
    commercial: (commercialCarSplit - carModalSplit.commercial) / numYears,
    private: (privateCarSplit - carModalSplit.private) / numYears,
    public: publicCarSplit, // Note that this is just HARDCODED TO 0 in the spreadsheet
  }
}

export const adjustOwnershipGrowthForTwoWheel = (modalSplit: ITwoWheelSplit, numYears: number, sharedMobilityLever: number) => {

  // First, let's calculate New Growth Rate for commercial twoWheels
  const baseCommercialGrowth = get(MODAL_SPLIT_BY_OWNERSHIP_BAU_GROWTH, [VehicleType.twoWheel, 'commercial']);
  const commercialTwoWheelGrowth = baseCommercialGrowth * (1 + (sharedMobilityLever * 0.3));
  const adjCommercialTwoWheelFraction = numYears * commercialTwoWheelGrowth + modalSplit.commercial;

  const twoWheelGrowth = MODAL_SPLIT_BY_OWNERSHIP_BAU_GROWTH[VehicleType.car];

  // Need to get old end percentage
  const prevPrivateTwoWheelSplit = numYears * twoWheelGrowth.private + modalSplit.private;
  const prevNonCommercialTotal = prevPrivateTwoWheelSplit;

  // Now, we apply normalizations!
  const nonCommercialTwoWheelFraction = 1 - adjCommercialTwoWheelFraction;

  // now we get the splits
  const commercialTwoWheelSplit = adjCommercialTwoWheelFraction;
  const privateTwoWheelSplit = (prevPrivateTwoWheelSplit / prevNonCommercialTotal) * nonCommercialTwoWheelFraction;

  // Sanity check KColumn in Adjustment Table
  // console.log('TwoWheel Splits', privateTwoWheelSplit, commercialTwoWheelSplit);
  return {
    commercial: (commercialTwoWheelSplit - modalSplit.commercial) / numYears,
    private: (privateTwoWheelSplit - modalSplit.private) / numYears,
  }
}



// WEBPACK FOOTER //
// ./src/store/selectors/modalSplit/leverAdjustByOwnership.ts